import {INVOICE_STATUS, INVOICE_STATUS_CODE} from "@/@core/data/enum/invoiceStatus";
import { getListInvoiceDetailFromModule } from '@/api/action-defines/e-invoice-management'
import { mapGetters, mapState } from 'vuex';
import { v4 as uuidv4 } from 'uuid'
import { PartnerCode } from "@/@core/data/enum/partnerCode.js";
import {EInvoiceActionCodes} from '@core/data/enum/menuCode';
import {getSitePartner} from '@/api/action-defines/site-management';
import router from '@/router';

export default {
  components: {
  },

  props: {
    invoiceDatas: {
      type: Array,
      default: () => []
    },
    moduleId: {
      type: [String, Number],
      default: null
    }
  },

  data() {
    return {
      dataSource: [],
      //Pagination
      paging: {
        PageSize: 10,
        PageIndex: 1,
      },
      totalPagination: {
        TotalRecord: 0,
        TotalPage: 10,
      },
      statusList: [...INVOICE_STATUS],
      isOpen: false,
      isCheckedAll: false,
      selectedItems: [],
      autoOpenWhenModuleToInvoice: true,
      partnerInfo: {},
    }
  },

  created() {
    // Tạo bản sao sâu của dataSource để tránh tham chiếu
    this.dataSource = JSON.parse(JSON.stringify(this.dataSource));
    
    this.dataSource.forEach((invoice, idx) => {
      if (invoice.InvoiceGroupItems && invoice.InvoiceGroupItems.length > 0){
        invoice.InvoiceGroupItems = this.groupedItems(idx);
      }
    })
    this.dataSource.forEach(invoice => {
      const invoiceAdded = this.$ls_Invoices.some(i => i.InvoiceId == invoice.InvoiceId);
      this.$set(invoice, 'isCollapsed', false);
      this.$set(invoice, 'isChecked', invoiceAdded);
      this.$set(invoice, 'isAdded', invoiceAdded);
      if (invoice.InvoiceGroupItems && invoice.InvoiceGroupItems.length > 0){
        invoice.InvoiceGroupItems.forEach(group => {
          const groupAdded = this.$ls_Groups.some(g => g.GroupItemId == group.GroupItemId);
          this.$set(group, 'isCollapsed', false);
          this.$set(group, 'isChecked', groupAdded);
          this.$set(group, 'isAdded', groupAdded);
          if (group.Items && group.Items.length > 0){
            group.Items.forEach(item => {
              const isAdded = !!this.$ls_Items.find(el => el.ItemId == item.ItemId);
              this.$set(item, 'isChecked', isAdded);
              this.$set(item, 'isAdded', isAdded);
              this.$set(item, 'isDisable', isAdded);
            }) 
          }
        })
      }
    })
  },

  methods: {
    close() {
      this.isOpen = false;
      this.$emit('add-footer', false);
    },
    changePage(paging) {
      this.paging = paging;
      if (this.invoiceDatas && this.invoiceDatas.length > 0) {
        this.fetchInvoiceDetail(this.invoiceDatas, this.paging.PageIndex, this.paging.PageSize);
      }
    },

    getInvoiceDetails() {
      
    },

    getTotalAmountByProp(list, prop) {
      if (!prop) {
        return this.formatNumber(0);
      }
      const arr = Array.isArray(list) ? list : [];
      // Tính tổng, parseFloat để chắc là số
      const total = arr.reduce((acc, item) => {
        const v = item['PaymentStatus'] ? (item[prop] || 0) : 0;
        return acc + v;
      }, 0);
      return this.formatNumber(total);
      
    },
    sumByProp(list, prop) {
      if (!Array.isArray(list) || !prop) return 0;
      return list.reduce((acc, item) => acc + this.toNumber(item !== null ? (item['PaymentStatus'] ? (item[prop] || 0) : 0) : 0), 0);
    },
    toNumber(v) {
      if (typeof v === 'number' && isFinite(v)) return v;
      if (v == null) return 0;
      // bỏ dấu phẩy, ký tự VND, khoảng trắng
      const n = parseFloat(String(v).replace(/[^\d.-]/g, ''));
      return isNaN(n) ? 0 : n;
    },
    formatNumber(number) {
      //Format 2000000 to 2.000.000
      return new Intl.NumberFormat('de-US').format(number);
    },

    selectAll() {
      this.dataSource.forEach(invoice => {
        invoice.isChecked = this.isCheckedAll;
        this.selectAllInInvoice(invoice);
      })
    },

    selectAllInInvoice(invoice) {
      if(this.isCheckedAll && !invoice.isChecked) {
        this.isCheckedAll = false;
      }
      if (invoice.InvoiceGroupItems && invoice.InvoiceGroupItems.length > 0){
        invoice.InvoiceGroupItems.forEach(group => {
          group.isChecked = invoice.isChecked;
          this.selectAllInGroup(invoice, group);
        })
      }
      this.$nextTick(() => {
        this.isCheckedAll = this.dataSource.every(el => el.isChecked == true);
      })
    },

    selectAllInGroup(invoice, group) {
      if (group.Items && group.Items.length > 0){
        group.Items.forEach(item => {
          if(item.isAdded) {
            return;
          }
          item.isChecked = group.isChecked;
          //If group checked add all item in group to selectedItems
          if(group.isChecked && !group.isAdded) {
            //Filter out the items already in selectedItems then add to selectedItems
            const filteredItems = group.Items.filter(item => !this.selectedItems.some(gItem => gItem.ItemId ==item.ItemId));
            this.selectedItems = [...this.selectedItems, ...filteredItems];
          //Else delete all item in group that exist in selectedItems
          } else {
            this.selectedItems = this.selectedItems.filter(item => !group.Items.some(gItem => gItem.ItemId == item.ItemId));
          }
        })
        this.$nextTick(() => {
          invoice.isChecked = invoice.InvoiceGroupItems.every(el => el.isChecked == true);
          this.isCheckedAll = invoice.isChecked && group.isChecked;
        })
      }
    },

    isOverLimit(item) {
      return this.calculateSpentPercentage(item) >= 100;
    },

    // single source of truth for disabling behavior
    updateOverLimitState(item) {
      const over = this.isOverLimit(item);
      // make both fields reactive
      //item.isDisable = over;
      //if(over) item.isChecked = true;
      return over;
    },

    selectItemGuarded(val, invoice, groupItem, item) {
      // if (this.updateOverLimitState(item)) {
      //   this.$nextTick(() => { item.isChecked = false; });
      //   return;
      // }
      this.selectItem(invoice, groupItem, item);
    },

    // call this whenever amounts change, or after loading data
    syncOverLimitChecked() {
      (this.dataSource.forEach(ds => ds.InvoiceGroupItems.forEach(ig => ig.Items.forEach(i => this.updateOverLimitState(i)))));
    },

    selectItem(invoice, group, item) {

      // Cập nhật selectedItems array
      if(item.isChecked && !item.isAdded) {
        const filteredItems = group.Items.filter(
          item => !this.selectedItems.some(gItem => gItem.ItemId == item.ItemId)
        );
        this.selectedItems = [...this.selectedItems, ...filteredItems];
      } else {
        this.selectedItems = this.selectedItems.filter(
          item => !group.Items.some(gItem => gItem.ItemId == item.ItemId)
        );
      }

      // Uncheck parents nếu item bị uncheck
      if (group.isChecked && !item.isChecked) group.isChecked = false;
      if (invoice.isChecked && !item.isChecked) invoice.isChecked = false;
      if (this.isCheckedAll && !item.isChecked) this.isCheckedAll = false;

      // Cập nhật state trong nextTick
      this.$nextTick(() => {
        if (item.isChecked && !item.isAdded) {
          if (!this.selectedItems.includes(item)) {
            this.selectedItems.push(item);
          }
        } else {
          this.selectedItems = this.selectedItems.filter(el => el !== item);
        }

        // Roll up checks
        group.isChecked = group.Items.every(el => el.isChecked === true);
        invoice.isChecked = group.isChecked && 
          invoice.InvoiceGroupItems.every(g => g.isChecked === true);
        this.isCheckedAll = invoice.isChecked && group.isChecked;
      });
    },


    handleClickAdd() {
      //Check if PMS has different Invoice type
      let haveDiff = false;
      this.dataSource.map(invoice => {
          if(!!invoice.IsTaxReduction43 && this.$ls_EInvoiceConfig.InvoiceType !== 'BH_INVOICE') {
            haveDiff = !invoice.InvoiceGroupItems.some(invoiceItem => this.selectedItems.some(item => item.ItemId == invoiceItem.ItemId));
          }
        });
      if(haveDiff) {
        this.$refs.confirmAdd.isOpen = true;
      } else {
        this.addToInvoice();
      }
    },
    
    calculateSpentPercentage(item) {
      if (!item.TotalAmount || item.TotalAmount === 0) return 0;
      
      const spentAmount = Array.isArray(item.paymentHistories) 
        ? item.paymentHistories.reduce((sum, payment) => sum + (payment.PaymentStatus ? (payment.AfterTaxAmount || 0) : 0), 0) 
        : 0;
      
      // Calculate percentage with 2 decimal precision
      const percentage = (spentAmount / item.TotalAmount) * 100;
      return Math.round(percentage * 100) / 100;
    },

    addToInvoice() {
      this.$refs.confirmAdd.isOpen = false;
      //Filtered added item to avoid adding extra item
      const filteredItem = JSON.parse(JSON.stringify(
        this.selectedItems.filter(item =>
          item?.isChecked == true
          && !this.$ls_Items.some(lsItem => lsItem.ItemId == item.ItemId)
        )
      ));

      const selectedGroups = [];
      (this.dataSource || []).forEach(invoice => {
        (invoice.InvoiceGroupItems || []).forEach(group => {
          if (group.isChecked) {
            const filteredItems = (group.Items || []).filter(it => it?.isDisable !== true && it?.isChecked == true);
            if (filteredItems.length > 0) {
              const clonedGroup = JSON.parse(JSON.stringify({
                ...group,
                Items: filteredItems,
              }));
              selectedGroups.push(clonedGroup);
            }
          }
        });
      });
      const selectedInvoices = [];
      this.dataSource.map(invoice => {
        if(invoice && invoice.isChecked) {
          selectedInvoices.push(JSON.parse(JSON.stringify(invoice)));
        }
      });

      //Add items to store
      filteredItem.forEach(item => {
        item.isChecked = true;
        //StoredGroupId to keep synchronize with store since GroupItemId has changed
        item.StoreGroupId = item.GroupItemId;
      })
      this.$store.commit('eInvoiceManagement/UPDATE_TABLE_ITEMS', [...structuredClone(this.$ls_Items), ...filteredItem]);
      //If group selected, add to store
      this.$store.commit('eInvoiceManagement/UPDATE_ADDED_GROUPS', [...structuredClone(this.$ls_Groups), ...selectedGroups]);
      //If invoice selected, add to store
      this.$store.commit('eInvoiceManagement/UPDATE_ADDED_INVOICES', [...structuredClone(this.$ls_Invoices), ...selectedInvoices]);
      
      this.$store.commit('eInvoiceManagement/SELECT_ALL', this.isCheckedAll);

      this.selectedItems.map(item => {
        const addedItem = filteredItem.some(fItem => fItem.ItemId == item.ItemId);
        if(!addedItem) {
          item.isAdded = true;
        }
      })
      selectedGroups.map(group => {
        group.isAdded = true;
      })
      selectedInvoices.map(invoice => {
        invoice.isAdded = true;
      })

      //Remove all selected item
      this.selectedItems = [];
    },

    getInvoiceStatusUI(statusId) {
      if(!this.statusList) return
     
      const status =  this.statusList.find(s => s.id == statusId)

      if(!status) return
      
      return {
        ...status,
        text: this.$t(status.text)
      }
    },

    openInvoiceDetail(ref) {
      function openEInvoiceInNewTab(ezInvoiceId) {
        const resolved = router.resolve({
          path: '/e-invoice',
          query: { ezInvoiceId }
        })
        // mở tab mới
        window.open(resolved.href, '_blank', 'noopener,noreferrer')
      }
      const { MINVOICE, CYBER_BILL , VIETTEL, VNPT, SUN, MISA} = PartnerCode;
      const { DRAFT, ORIGINAL, ADJUSTMENT, REPLACEMENT } = INVOICE_STATUS_CODE;

      if ([MINVOICE, CYBER_BILL].includes(this.partnerInfo.PartnerCode)
          && ([DRAFT].includes(this.EinvoiceDetailData.StatusEInvoice)
              || ([DRAFT, ORIGINAL, ADJUSTMENT, REPLACEMENT].includes(this.EinvoiceDetailData.StatusEInvoice) && !this.EinvoiceDetailData.StatusSign))
          && this.$lsAllowOperation(EInvoiceActionCodes.EDIT)
      ){
        openEInvoiceInNewTab(ref.SearchId);
      }else if ([VIETTEL, VNPT, SUN, MISA].includes(this.partnerInfo.PartnerCode)
          && [DRAFT].includes(this.EinvoiceDetailData.StatusEInvoice)
          && this.$lsAllowOperation(EInvoiceActionCodes.EDIT)
      ){
        openEInvoiceInNewTab(ref.SearchId);
      }else {
        openEInvoiceInNewTab(ref.SearchId);
      }
      },

    // groupedItems(idx) {
    //   const groups = this.dataSource[idx].InvoiceGroupItems.reduce((groups, item) => {
    //     if(!groups[item.GroupItemId]) {
    //       groups[item.GroupItemId] = [];
    //     }

    //     groups[item.GroupItemId].push(item);
    //     return groups;
    //   }, {})

    //   const groupsItems = Object.values(groups);

    //   return groupsItems.map(group => {
    //     const groupItem = {
    //       GroupItemId: group[0].GroupItemId,
    //       GroupItemName: group[0].GroupItemName,
    //       Items: group,
    //       isChecked: false,
    //       isCollapsed: false,
    //     }
    //     this.$set(groupItem, 'isCollapsed', false);
    //     this.$set(groupItem, 'isChecked', false);
    //     this.$set(groupItem, 'isAdded', false);
    //     return groupItem;
    //   })
    // },

    groupedItems(idx) {
      const items = Array.isArray(this.dataSource[idx].InvoiceGroupItems)
        ? JSON.parse(JSON.stringify(this.dataSource[idx].InvoiceGroupItems))
        : [];
      const mapGroups = items.reduce((groups, item) => {
        (groups[item.GroupItemId] ||= []).push(item);
        return groups;
      }, {});
      return Object.values(mapGroups).map(group => {
        const groupItem = {
          GroupItemId: group[0].GroupItemId,
          GroupItemName: group[0].GroupItemName,
          Items: JSON.parse(JSON.stringify(group)),
          isChecked: false,
          isCollapsed: false,
          isAdded: false,
        };
        return groupItem;
      });
    },

    async fetchInvoiceDetail(invoiceDatas, pageIndex, pageSize) {
      
      const BodyData = {
        ModuleId: this.moduleId,
        DataInvoices: invoiceDatas,
        PageIndex : pageIndex,
        PageSize : pageSize
      };

      try {
        const res = await getListInvoiceDetailFromModule({ BodyData });
        
        if (res.StatusCode == 200) {
          // Tạo bản sao sâu của dữ liệu để tránh bị thay đổi khi dữ liệu gốc thay đổi
          this.dataSource = JSON.parse(JSON.stringify(res.Data || [])).map(inv => ({
            ...inv,
            InvoiceGroupItems: Array.isArray(inv.InvoiceGroupItems) 
              ? inv.InvoiceGroupItems 
              : []
          }));
          this.$nextTick(this.initDataSource);
          this.$nextTick(() => {
            let isRedirected = sessionStorage.getItem('isRedirected');
            if (isRedirected === "true"){
              sessionStorage.setItem('isRedirected', 'false');
                this.autoOpenWhenModuleToInvoice = false;
                this.isCheckedAll = true;
                this.selectAll();
                this.handleClickAdd();
            }
          });
          

        } else {
          this.$bvToast.toast('Không có dữ liệu chi tiết hóa đơn', {
            title: 'Thông báo',
            variant: 'warning',
            solid: true,
          });
        }
      } catch (err) {
        console.error('Lỗi khi lấy chi tiết hóa đơn:', err);
        this.$bvToast.toast('Không thể lấy chi tiết hóa đơn', {
          title: 'Lỗi',
          variant: 'danger',
          solid: true,
        });
      }
    },
    moduleToEInvoiceAddDetail(){

    },

    async getPartnerInfo() {
      const res = await getSitePartner();
      this.partnerInfo = res.Data;
    },

    initDataSource() {
      // Tạo bản sao sâu của dataSource trước khi xử lý để tránh tham chiếu
      this.dataSource = JSON.parse(JSON.stringify(this.dataSource));
      
      this.dataSource.forEach((invoice, idx) => {
        // grouping có guard
        if (Array.isArray(invoice.InvoiceGroupItems) && invoice.InvoiceGroupItems.length) {
          invoice.InvoiceGroupItems = this.groupedItems(idx);
        }
      });
      // sau đó set trạng thái isChecked/isAdded tương tự như trong created()
      this.dataSource.forEach(invoice => {
        const invoiceAdded = this.$ls_Invoices.some(i => i.InvoiceId == invoice.InvoiceId);
        this.$set(invoice, 'isCollapsed', false);
        this.$set(invoice, 'isChecked', invoiceAdded);
        this.$set(invoice, 'isAdded', invoiceAdded);
        if (invoice.InvoiceGroupItems && invoice.InvoiceGroupItems.length > 0){
          invoice.InvoiceGroupItems.forEach(group => {
            const groupAdded = this.$ls_Groups.some(g => g.GroupItemId == group.GroupItemId);
            this.$set(group, 'isCollapsed', false);
            this.$set(group, 'isChecked', groupAdded);
            this.$set(group, 'isAdded', groupAdded);
            if (group.Items && group.Items.length > 0){
              group.Items.forEach(item => {
                const isAdded = !!this.$ls_Items.find(el => el.ItemId == item.ItemId);
                this.$set(item, 'isChecked', isAdded);
                this.$set(item, 'isAdded', isAdded);
                this.$set(item, 'isDisable', isAdded);
              }) 
            }
          })
        }
      })
    },

    getTotalGroupAmount(list, prop) {
      if (!prop) {
        return this.formatNumber(0);
      }
      const arr = Array.isArray(list) ? list : [];
      // Tính tổng, parseFloat để chắc là số
      const total = arr.reduce((acc, item) => {
        const v = item['AfterTaxAmount'] ? (item[prop] || 0) : 0;
        return acc + v;
      }, 0);
      return this.formatNumber(total);

    },

  },

  mounted() {
    this.syncOverLimitChecked();
  },

  updated() {
    this.syncOverLimitChecked();
  },
  computed: {
    ...mapState({
      $ls_Items: (state) => state.eInvoiceManagement.items,
      $ls_filledItems: (state) => state.eInvoiceManagement.filledItems,
      $ls_Groups: (state) => state.eInvoiceManagement.groups,
      $ls_Invoices: (state) => state.eInvoiceManagement.invoices,
      $ls_IsSelectedAll: (state) => state.eInvoiceManagement.isSelectedAll,
      $ls_EInvoiceConfig: (state) => state.eInvoiceManagement.eInvoiceConfig,
    }),
    ...mapGetters({
      $ls_GetTableItems: 'eInvoiceManagement/getTableItems',
    }),
    isDisableAddToInvoice() {
      return this.selectedItems.length <= 0;
    },
    totalPaymentAmount() {
    return this.item.paymentHistories.reduce((sum, payment) => sum + payment.AfterTaxAmount, 0);
    },
  },

  watch: {
    // Khi danh sách Items thay đổi (ví dụ: filter, replace), cập nhật trạng thái isAdded/isChecked
    $ls_Items(newVal, oldVal) {
      console.log('Items changed from', oldVal, 'to', newVal);
      this.dataSource.forEach(invoice => {
        if (invoice.InvoiceGroupItems && invoice.InvoiceGroupItems.length > 0){
          invoice.InvoiceGroupItems.forEach(group => {
            if (group.Items && group.Items.length > 0){
              group.Items.forEach(item => {
                let isAdded = false;
                if (this.actionType == 'replace_invoice') {
                  isAdded = oldVal.some(el => el.ItemId == item.ItemId);
                } else {
                  isAdded = newVal.some(el => el.ItemId == item.ItemId);
                }
                this.$set(item, 'isAdded', isAdded);
                this.$set(item, 'isChecked', isAdded);
              });
            }
          });
        }
      });
    },
  
    // Khi modal mở, gọi API lấy chi tiết và cập nhật isAdded/isChecked
    isOpen(opened) {
      if (!opened) return;
  
      // 1. Gọi API với invoiceDatas đã chọn
      if (this.invoiceDatas && this.invoiceDatas.length > 0) {
        this.totalPagination.TotalRecord = this.invoiceDatas.length;
        this.totalPagination.TotalPage = Math.ceil(this.invoiceDatas.length / this.paging.PageSize);

        const isRedirected = sessionStorage.getItem('isRedirected');
        if (isRedirected === "true") {
          // Fetch tất cả record một lần để auto-select hoạt động đúng
          this.fetchInvoiceDetail(this.invoiceDatas, 1, this.invoiceDatas.length);
        } else {
          this.fetchInvoiceDetail(this.invoiceDatas, 1, this.paging.PageSize);
        }
      }
  
      // 2. Cập nhật trạng thái isAdded/isChecked cho toàn bộ items dựa trên $ls_Items
      this.dataSource.forEach(invoice => {
        if (invoice.InvoiceGroupItems && invoice.InvoiceGroupItems.length > 0){
          invoice.InvoiceGroupItems.forEach(group => {
            if (group.Items && group.Items.length > 0){
              group.Items.forEach(item => {
                const isAdded = this.$ls_Items.some(el => el.ItemId == item.ItemId);
                this.$set(item, 'isAdded', isAdded);
                this.$set(item, 'isChecked', isAdded);
              });
            }
          });
        }
      });
    },
  
    // Khi Group list thay đổi
    $ls_Groups(newVal) {
      this.dataSource.forEach(invoice => {
        if (invoice.InvoiceGroupItems && invoice.InvoiceGroupItems.length > 0){
          invoice.InvoiceGroupItems.forEach(g => {
            const isAdded = newVal.some(el => el.GroupItemId == g.GroupItemId);
            this.$set(g, 'isAdded', isAdded);
            this.$set(g, 'isChecked', isAdded);
          });
        }
      });
    },
  
    // Khi Invoice list thay đổi
    $ls_Invoices(newVal) {
      this.dataSource.forEach(invoice => {
        const isAdded = newVal.some(el => el.InvoiceId == invoice.InvoiceId);
        this.$set(invoice, 'isAdded', isAdded);
        this.$set(invoice, 'isChecked', isAdded);
      });
    },
  
    // Khi có chọn/tắt tất cả
    $ls_IsSelectedAll(newVal) {
      this.$set(this, 'isCheckedAll', newVal);
    },
  },
  
}